"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./styles"));

var _FlexGrow = _interopRequireDefault(require("../components/FlexGrow1"));

var _Separator = _interopRequireDefault(require("../components/Separator"));

var _BadgeCertificateInfo = _interopRequireDefault(require("../components/BadgeCertificateInfo"));

var _ContentImage = _interopRequireDefault(require("../components/ContentImage"));

var _SubTitle = _interopRequireDefault(require("../components/SubTitle"));

var _ContentNameContainer = _interopRequireDefault(require("../components/ContentNameContainer"));

var _PathDetails = _interopRequireDefault(require("../components/PathDetails"));

var _DurationInfo = _interopRequireDefault(require("../components/DurationInfo"));

function getTopBarInfos(props) {
  var topInfos = [];
  var theme = props.theme,
      contentType = props.contentType,
      certificateInfo = props.certificateInfo,
      badgeInfo = props.badgeInfo,
      duration = props.duration,
      pathInfo = props.pathInfo;
  topInfos.push(_react.default.createElement("div", {
    key: "contentType",
    className: s.contentType(theme)
  }, contentType));

  if (pathInfo) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_PathDetails.default, props));
  }

  if (duration) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_DurationInfo.default, props));
  }

  if (badgeInfo) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_BadgeCertificateInfo.default, (0, _extends2.default)({
      key: "badgeInfo"
    }, props, {
      type: "badge"
    })));
  }

  if (certificateInfo) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_BadgeCertificateInfo.default, (0, _extends2.default)({
      key: "certificateInfo"
    }, props, {
      type: "certificate"
    })));
  }

  return topInfos;
}

function ContentCardAdminMedium(props) {
  var theme = props.theme,
      contentId = props.contentId,
      className = props.className,
      bottomBarInfo = props.bottomBarInfo;
  var topBarInfos = getTopBarInfos(props);
  return _react.default.createElement("div", {
    key: contentId,
    className: (0, _classnames.default)(s.root(theme), className)
  }, _react.default.createElement("div", {
    className: s.content
  }, _react.default.createElement(_ContentImage.default, (0, _extends2.default)({}, props, {
    height: 56,
    width: 56,
    badgeIconSize: 44,
    className: s.contentImage
  })), _react.default.createElement("div", {
    className: s.contentInfo
  }, _react.default.createElement("div", {
    className: s.topInfo
  }, topBarInfos), _react.default.createElement(_ContentNameContainer.default, props), _react.default.createElement(_FlexGrow.default, null), _react.default.createElement(_SubTitle.default, props), bottomBarInfo)), props.children);
}

var _default = (0, _emotionTheming.withTheme)(ContentCardAdminMedium);

exports.default = _default;